export default __webpack_public_path__ + "static/media/a011-example13_sc.2155783c.png";